import React, { useMemo, useState } from 'react';
import './App.css';
import IndexCard from './IndexCard';
import { InputFormat } from './types';

const makePrefixes = (): string[] => {
  const prefixes: string[] = [];
  const A = 'A'.charCodeAt(0);
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      prefixes.push(String.fromCharCode(A + i) + String.fromCharCode(A + j));
    }
  }
  return prefixes;
};

const makeBatch = (prefix: string): InputFormat[] => {
  const arr: InputFormat[] = [];
  for (let i = 0; i < 100; i++) {
    const suffix = i.toString().padStart(2, '0');
    arr.push({ id: `${prefix}${suffix}`, batchId: prefix });
  }
  return arr;
};

const App: React.FC = () => {
  const prefixes = useMemo(() => makePrefixes(), []);
  const [selected, setSelected] = useState<string>('AI');
  const [cardTitle, setCardTitle] = useState<string>('Survey Card - NE G&P');
  const [draftTitle, setDraftTitle] = useState<string>(cardTitle);

  const cards = useMemo(() => {
    const batch = makeBatch(selected);
    return batch.map((x, i) => (
      <IndexCard key={i} identifier={x.id} batchIdentifier={x.batchId} title={cardTitle} />
    ));
  }, [selected, cardTitle]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="no-print" style={{ marginBottom: '1rem' }}>
          <label style={{ marginRight: '0.5rem' }} htmlFor="prefix-select">Batch prefix:</label>
          <select
            id="prefix-select"
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          >
            {prefixes.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>

          <label style={{ marginLeft: '1rem', marginRight: '0.5rem' }} htmlFor="card-title">Card title:</label>
          <input
            id="card-title"
            type="text"
            value={draftTitle}
            onChange={(e) => setDraftTitle(e.target.value)}
            onBlur={() => setCardTitle(draftTitle)}
            onKeyDown={(e) => { if (e.key === 'Enter') (e.currentTarget as HTMLInputElement).blur(); }}
            style={{ minWidth: '220px' }}
          />
        </div>
        {cards}
      </header>
    </div>
  );
};

export default App;
